module.exports = __webpack_public_path__ + "static/media/undraw_active_options_8je6.5105992b.png";